import { render, staticRenderFns } from "./AuthPermission.vue?vue&type=template&id=3d4c4bcf&scoped=true"
import script from "./AuthPermission.vue?vue&type=script&lang=js"
export * from "./AuthPermission.vue?vue&type=script&lang=js"
import style0 from "./AuthPermission.vue?vue&type=style&index=0&id=3d4c4bcf&lang=scss&scoped=true"
import style1 from "./AuthPermission.vue?vue&type=style&index=1&id=3d4c4bcf&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c4bcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shmily/Desktop/Knowledge-base/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4c4bcf')) {
      api.createRecord('3d4c4bcf', component.options)
    } else {
      api.reload('3d4c4bcf', component.options)
    }
    module.hot.accept("./AuthPermission.vue?vue&type=template&id=3d4c4bcf&scoped=true", function () {
      api.rerender('3d4c4bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/components/AuthPermission.vue"
export default component.exports